module.exports = __webpack_public_path__ + "static/gatsby-2347493d8c3633ba5395874f767c4f0c.png";